import React from "react";
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicFormControls, BaasicButton } from 'core/components';
import { orderingDoctorItemRender, orderingDoctorValueRender } from 'themes/components/select/OrderingDoctorDropdownRender';

function PatientTemplateCustomOrderingDoctorChangeModalTemplate({ patientTemplateCustomOrderingDoctorChangeModalStore, t }) {
    const {
        doctorStore,
        form,
        modalParams
    } = patientTemplateCustomOrderingDoctorChangeModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Change Provider for Forms</h3>
            </div>
            <div className="modal__body">
                <div className="form__group col">
                    <BaasicFieldDropdown field={form.$('customOrderingDoctorId')} store={doctorStore} labelDisplayed={false} itemRender={orderingDoctorItemRender} valueRender={orderingDoctorValueRender}/>
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Change"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section>
    )
}

PatientTemplateCustomOrderingDoctorChangeModalTemplate.propTypes = {
    patientTemplateCustomOrderingDoctorChangeModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientTemplateCustomOrderingDoctorChangeModalTemplate);